export class Note {
    /**
             * Midi to frequency
             * @see https://www.inspiredacoustics.com/en/MIDI_note_numbers_and_center_frequencies
             */
    // let midi = e5.Calc.clamp(note.midi + this._pitch, 0, 127);
    // let name = Tone.Frequency(midi, "midi");
    // this._samplers[note.track.index].trigger({
    //     name: name as any,
    //     dur: isNaN(duration) ? note.dur / this._speed : duration,
    //     velocity: note.velocity
    // }, time);


    // public static transpose(note: string, alter: number, transpose: number): {
    //     octave: number;
    //     step: string;
    //     midi: number;
    //     note: string;
    //     alter: number;
    // } {
    //     const steps = ["A", "B", "C", "D", "E", "F", "G"];

    //     // let name = Tone.Frequency(midi, "midi");

    //     //@ts-ignore
    //     // const fc = new Tone.FrequencyClass(null, note);
    //     // let f = new Tone.Frequency(fc.toMidi(), "midi");
    //     // f = f.transpose(transpose);
    //     // console.log("NAME", note, "MIDI", fc.toMidi(), "=>", "NAME", f.toNote(), "MIDI", f.toMidi());

    //     // const fc = new Tone.FrequencyClass(null, note);
    //     // let f = new Tone.Frequency(fc.toMidi(), "midi");
    //     // f = f.transpose(transpose);
    //     // console.log("NAME", note, "MIDI", fc.toMidi(), "=>", "NAME", f.toNote(), "MIDI", f.toMidi());

    //     // transpose = 0;

    //     // note = "A5";
    //     // transpose = 2;

    //     // note = "C#4";
    //     // note = "A#3";
    //     // note = "B#3";
    //     // note = "Bb3";

    //     //Bb3 -> A#3
    //     //Chromatic alterations -->> alter, step and octave
    //     //https://musescore.org/en/node/319877
    //     //https://www.guitarland.com/MusicTheoryWithToneJS/PlayScaleDegrees.html
    //     //https://github.com/Tonejs/Tone.js/blob/bfa600399fe15b8cbc5b2f19cb9c7043daf608b9/Tone/core/type/Frequency.test.ts#L112

    //     // const steps = ["A", "B", "C", "D", "E", "F", "G"];
    //     if (note[1] == "b") {
    //         let idx = steps.indexOf(note[0]) - 1;
    //         if (idx < 0) {
    //             idx = steps.length - 1;
    //         }
    //         note = steps[idx] + "#" + (note[2] || "");
    //     }

    //     // const lookup = {
    //     //     "G#9": "Ab9",
    //     //     "F#9": "Gb9",
    //     //     "D#9": "Eb9",
    //     //     "C#9": "Db9",
    //     //     "A#8": "Bb8",
    //     //     "G#8": "Ab8",
    //     //     "F#8": "Gb8",
    //     //     "D#8": "Eb8",
    //     //     "C#8": "Db8",
    //     //     "A#7": "Bb7",
    //     //     "G#7": "Ab7",
    //     //     "F#7": "Gb7",
    //     //     "D#7": "Eb7",
    //     //     "C#7": "Db7",
    //     //     "A#6": "Bb6"
    //     // };

    //     // let off = 0;
    //     // if (note != Tone.Frequency(note).toNote()) {
    //     // off = alter;
    //     // console.log(note, "alter", alter);
    //     // }
    //     // const f = Tone.Frequency(note, "note").transpose(transpose);

    //     const f = Tone.Frequency(note, "note").transpose(transpose);

    //     const midi = f.toMidi();
    //     const octave = Math.floor(midi / 12) - 1;
    //     // const rNote = String(Tone.Frequency(midi, "midi").toNote());

    //     let rNote = String(f.toNote());

    //     if (rNote[1] == "#") {
    //         let idx = steps.indexOf(rNote[0]) + 1;
    //         if (idx > steps.length - 1) {
    //             idx = 0;
    //         }
    //         rNote = steps[idx] + "b" + (rNote[2] || "");
    //     }




    //     // const alterSign = rNote[1] == "b" ? 1 : (rNote[1] == "b" ? -1 : 0);
    //     const alterSign = alter;//alter * - 1;//rNote[1] == "#" ? 1 : (rNote[1] == "b" ? -1 : 0);
    //     const step = rNote[0];

    //     console.log(note, "=>", rNote);


    //     console.log("GPT", note, "=>", this.transposeChromatic(note, transpose));//, this.transposeDiatonic(note, transpose, "C"))

    //     // console.log(note, "=>", rNote, "Octave", octave, "Step", step, "Alter", alter, "Transpose", transpose);

    //     return {
    //         octave: octave,
    //         midi: midi,
    //         step: step,
    //         note: rNote,
    //         alter: alterSign
    //     };
    // }

    public static transpose(note: string, transpose: number): string {


        // return note;
        // transpose = 4;

        // console.log("TONEJS", transpose, note, "=>", (Tone.Frequency(note, "note") as any).transpose(transpose).toNote());
        // console.log("GPT   ", transpose, note, "=>", this.transposeChromatic(note, transpose));
        // console.log("LIB   ", transpose, note, "=>", this.transposeChord(note, transpose));

        return (Tone.Frequency(note, "note") as any).transpose(transpose).toNote();
        // return this.transposeChromatic(note, transpose);
        // return this.transposeChord(note, transpose);
    }


    /**
     * Transposes a note in Western music notation by a given number of diatonic steps within a given key.
     * Note that it assumes a default octave of 4 if no octave is specified.
     * 
     * @param note The note to transpose, as a string in Western music notation (e.g. "C#4").
     * @param steps The number of diatonic steps to transpose the note by, as an integer.
     * @param key The key of the current scale, as a string (e.g. "G").
     * @returns The transposed note, as a string in Western music notation (e.g. "E#5").
     */
    public static transposeDiatonic(note: string, steps: number, key: string): string {

        const noteRegex = /^([A-G])(#|b)?(\d+)?$/;
        const [, noteName, accidental = '', octave = "4"] = note.match(noteRegex) || [];

        const notes = ['C', 'D', 'E', 'F', 'G', 'A', 'B'];
        const index = notes.indexOf(note[0]);
        const isSharp = accidental == '#';
        const isFlat = accidental == 'b';
        const alter = isSharp ? 1 : isFlat ? -1 : 0;

        const keyNotes = notes.slice(notes.indexOf(key)).concat(notes.slice(0, notes.indexOf(key)));
        const transposedIndex = (index + steps + alter) % 7;
        const transposedNoteName = keyNotes[transposedIndex];
        const transposedOctave = octave + Math.floor((index + steps + alter) / 7);
        const transposedAccidental = (transposedNoteName === 'C' || transposedNoteName === 'F') ? (isSharp ? '' : isFlat ? 'b' : '') :
            (transposedNoteName === 'B' || transposedNoteName === 'E') ? (isFlat ? '' : isSharp ? '#' : '') :
                (isSharp ? '#' : isFlat ? 'b' : '');

        return `${transposedNoteName}${transposedAccidental}${transposedOctave}`;
    }

    /**
     * Transposes a note in Western music notation by a given number of half-steps (semitones).
     * Note that it assumes a default octave of 4 if no octave is specified. 
     * 
     * @param note The note to transpose, as a string in Western music notation (e.g. "C#4").
     * @param halfSteps The number of half-steps to transpose the note by, as an integer.
     * @returns The transposed note, as a string in Western music notation (e.g. "E#5").
     * @throws An error if the note string is invalid, the note name or accidental is invalid,
     *         or the transposed note is out of range.
     */
    public static transposeChromatic(note: string, halfSteps: number): string {

        const noteRegex = /^([A-G])(#|b)?(\d+)?$/;
        const [, noteName, accidental = '', octave = '4'] = note.match(noteRegex) || [];

        if (!noteName) {
            throw new Error('Invalid note format: ' + note);
        }

        const noteLetters = ["C", "D", "E", "F", "G", "A", "B"];
        const regex = /^([A-G])([#b]?)(\d+)$/;

        const matches = note.match(regex);
        if (!matches) {
            throw new Error("Invalid note format");
        }

        const letter = matches[1];

        const letterIndex = noteLetters.indexOf(letter);
        if (letterIndex === -1) {
            throw new Error("Invalid note letter");
        }

        let newLetterIndex = letterIndex + halfSteps;
        let newOctave = parseInt(octave);

        while (newLetterIndex < 0) {
            newLetterIndex += noteLetters.length;
            newOctave--;
        }

        while (newLetterIndex >= noteLetters.length) {
            newLetterIndex -= noteLetters.length;
            newOctave++;
        }

        const newLetter = noteLetters[newLetterIndex];
        const newAccidental = accidental === "#" ? "#" : accidental === "b" ? "b" : "";
        const newNote = `${newLetter}${newAccidental}${newOctave}`;

        return newNote;
    }

    /**
     * Transposes an array of music notes by a given number of half-steps.
     * @param notes - An array of music notes in the format of 'C#4', 'Eb3', etc.
     * @param halfSteps - The number of half-steps to transpose. Positive 
     * for up, negative for down.
     * @returns An array of transposed music notes.
     * 
     * @author Chat GPT
     */
    public static transposeNote(note: string, halfSteps: number): string {
        const noteRegex = /^([A-G])(#|b)?(\d+)?$/;
        const [, noteName, accidental = '', octave = '4'] = note.match(noteRegex) || [];

        if (!noteName) {
            throw new Error('Invalid note format: ' + note);
        }

        const noteIndex = 'C C#D D#E F F#G G#A A#B'.indexOf(noteName + accidental);
        if (noteIndex !== -1) {
            const transposedIndex = (noteIndex + halfSteps) % 12;
            const transposedNoteName = 'C C#D D#E F F#G G#A A#B'.slice(transposedIndex * 2, transposedIndex * 2 + 2);
            const transposedOctave = parseInt(octave, 10) + Math.floor((noteIndex + halfSteps) / 12);
            return `${transposedNoteName}${accidental || ''}${transposedOctave}`;
        }
        return note;
    }

    /**
     * 
     * In this program, we first define an object notes that maps each 
     * note name (e.g. "C", "D", etc.) to its corresponding MIDI value. 
     * We then use a regular expression to parse the input note string 
     * and extract the note name, accidental (if any), and octave (if any). 
     * We then compute the MIDI value by looking up the note name and 
     * adding the octave number and a constant offset. Finally, we adjust 
     * the MIDI value if there is a sharp or flat accidental.
     * This program should work for most standard Western music notation. 
     * Note that it assumes a default octave of 4 if no octave is specified. 
     * Also note that MIDI values range from 0 to 127, so this program will 
     * throw an error if the computed MIDI value is outside that range.
     * 
     * @param note 
     * @returns The midi value.
     */
    public static toMidi(note: string): number {
        const notes: { [key: string]: number } = {
            "C": 0, "C#": 1, "Db": 1, "D": 2, "D#": 3, "Eb": 3, "E": 4, "F": 5,
            "F#": 6, "Gb": 6, "G": 7, "G#": 8, "Ab": 8, "A": 9, "A#": 10, "Bb": 10, "B": 11
        };
        const match = /^([A-Ga-g](#|b)?)(\d)?$/.exec(note);
        if (!match) {
            throw new Error("Invalid note: " + note);
        }
        const [, noteName, accidental, octaveStr] = match;
        const octave = octaveStr ? parseInt(octaveStr, 10) : 4;
        let midiNote = notes[noteName.toUpperCase()] + (octave + 1) * 12;
        if (isNaN(midiNote)) {
            throw new Error("Invalid note: " + note);
        }
        if (accidental === "#") {
            midiNote += 1;
        } else if (accidental === "b") {
            midiNote -= 1;
        }

        if (midiNote < 0 || midiNote > 127) {
            throw new Error("Invalid note: " + note);
        }

        return midiNote;
    }

    /**
     * Converts a MIDI value to a note in Western notation.
     * @param midiValue The MIDI value to convert.
     * @returns The note in Western notation as a string.
     */
    public static fromMidi(midiValue: number): string {
        const notes = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];
        const octave = Math.floor((midiValue - 12) / 12) + 1; // Add 1 to start octave at 1
        const noteIndex = midiValue % 12;
        const note = notes[noteIndex];
        return `${note}${octave}`;
    }

    public static fromPitch(step: string, alter: number, octave: number | string): string {
        let name = step;
        if (alter > 0) {
            name += "#";
        } else if (alter < 0) {
            name += "b";
        }
        name += octave;
        return name;
    }

    /**
     * Calculates the octave of a given note in Western music notation.
     *
     * @param note The note in the format of a letter followed by 
     * an octave number (e.g. "C4", "G#3", "F#5").
     * @returns The octave number of the note.
     * @throws An error if an invalid note format is passed.
     */
    public static getOctave(note: string): number {

        const noteRegex = /^([A-G])(#|b)?(\d+)?$/;
        const [, noteName, accidental = '', octave = '4'] = note.match(noteRegex) || [];

        if (!noteName) {
            throw new Error('Invalid note format: ' + note);
        }

        return parseInt(octave);

        // function getValue(noteLetter: string): number {
        //     switch (noteLetter) {
        //         case 'C':
        //             return 0;
        //         case 'D':
        //             return 1;
        //         case 'E':
        //             return 2;
        //         case 'F':
        //             return 3;
        //         case 'G':
        //             return 4;
        //         case 'A':
        //             return 5;
        //         case 'B':
        //             return 6;
        //         default:
        //             throw new Error(`Invalid note: ${noteLetter}`);
        //     }
        // }

        // const noteValue = getValue(note[0]);
        // const octave = parseInt(note[note.length - 1]);

        // if (noteValue >= 4) {
        //     return octave - 1;
        // }

        // return octave;
    }

    /**
     * Parses a note in Western music notation and returns the alter 
     * (i.e. the number of semitones the note is shifted from its 
     * natural position).
     *
     * @param note The note in the format of a letter followed by an 
     * optional accidental (e.g. "C", "C#", "Db").
     * @returns The alter value of the note (1 for sharp, -1 for flat, 
     * 0 for natural).
     */
    public static getAlter(note: string): number {
        // Check if the note has an accidental (i.e. sharp or flat) and extract it from the second character.
        const accidental = note.length > 2 ? note[1] : null;

        // Initialize the alter value to 0 (i.e. the note is natural).
        let alter = 0;

        switch (accidental) {
            case '#':
                alter = 1;
                break;
            case 'b':
                alter = -1;
                break;
            default:
                alter = 0;
                break;
        }

        return alter;
    }

    public static identifyKeySignature(notes: string[]) {
        const notesInFifths = ['Cb', 'Gb', 'Db', 'Ab', 'Eb', 'Bb', 'F', 'C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#'];
        const notesMap = new Map<number, number>();

        // Count the number of occurrences of each note
        for (let note of notes) {


            const noteRegex = /^([A-G])(#|b)?(\d+)?$/;
            const [, noteName, accidental = '', octave = '4'] = note.match(noteRegex) || [];

            if (!noteName) {
                continue;
            }

            const name = noteName.toUpperCase() + accidental.toLowerCase();
            if (!notesInFifths.includes(name)) {
                continue;
            }

            const index = notesInFifths.indexOf(name);

            if (index === -1) {
                continue;
            }

            if (notesMap.has(index)) {
                notesMap.set(index, notesMap.get(index)! + 1);
            } else {
                notesMap.set(index, 1);
            }
        }

        if(notesMap.size === 0){
            return null;
        }

        // Find the most common note and assume that's the key
        const mostCommonNoteIndex = Array.from(notesMap.entries()).reduce((a, b) => b[1] > a[1] ? b : a)[0];

        // The number of fifths from the most common note to C is the number of sharps or flats in the key signature
        const numFifths = mostCommonNoteIndex - 7;
        let mode:"major" | "minor" = 'minor';

        // Determine whether the key is major or minor
        if (numFifths >= 0) {
            mode = 'major';
        }

        // Return the number of fifths and the mode
        return {
            fifths: Math.abs(numFifths),
            note: notesInFifths[Math.abs(numFifths)],
            mode: mode
        };
    }


    /**
     * Converts a western music note to the corresponding number of fifths.
     * @param note The note to convert, as a string (e.g. 'C', 'F#', 'Bb')
     * @returns The number of fifths from the note to the note C. For example, 
     *          'A' would return -3, since A is 3 notes to the left of C in the 
     *          circle of fifths, and 'F#' would return 6, since F# is 6 notes 
     *          to the right of C in the circle of fifths.
     * @throws An error if the provided note is not a valid western music note. 
     *         Valid notes include: C, C#, Db, D, D#, Eb, E, F, F#, Gb, G, G#, Ab, A, A#, Bb, B.
     */
    public static getNumberOfFifths(note: string): number {
        const notesInFifths = ['Cb', 'Gb', 'Db', 'Ab', 'Eb', 'Bb', 'F', 'C', 'G', 'D', 'A', 'E', 'B', 'F#', 'C#'];
        const index = notesInFifths.indexOf(note);

        if (index === -1) {
            throw new Error(`Invalid note: ${note}`);
        }

        return index - 7; // The 7th note (C) is considered 0 fifths
    }

    /**
     * Parses a note in Western music notation and returns the step (i.e. the letter name of the note without the accidental).
     *
     * @param note The note in the format of a letter followed by an optional accidental (e.g. "C", "C#", "Db").
     * @returns The step of the note (i.e. the letter name of the note without the accidental).
     */
    public static getStep(note: string): string {
        // Extract the first character of the note string, which represents the step.
        const step = note[0];

        return step;
    }

    public static transposeChord(note: string, delta: number, targetKey: string = "C") {
        const keys = [
            { name: 'Ab', value: 0, type: 'F' },
            { name: 'A', value: 1, type: 'N' },
            { name: 'A#', value: 2, type: 'S' },
            { name: 'Bb', value: 2, type: 'F' },
            { name: 'B', value: 3, type: 'N' },
            { name: 'C', value: 4, type: 'N' },
            { name: 'C#', value: 5, type: 'S' },
            { name: 'Db', value: 5, type: 'F' },
            { name: 'D', value: 6, type: 'N' },
            { name: 'D#', value: 7, type: 'S' },
            { name: 'Eb', value: 7, type: 'F' },
            { name: 'E', value: 8, type: 'N' },
            { name: 'F', value: 9, type: 'N' },
            { name: 'F#', value: 10, type: 'S' },
            { name: 'Gb', value: 10, type: 'F' },
            { name: 'G', value: 11, type: 'N' },
            { name: 'G#', value: 0, type: 'S' }
        ];

        var getKeyByName = function (name: string) {
            if (name.charAt(name.length - 1) == "m") {
                name = name.substring(0, name.length - 1);
            }
            for (var i = 0; i < keys.length; i++) {
                if (name == keys[i].name) {
                    return keys[i];
                }
            }
        };
        var getChordRoot = function (input: string) {
            if (input.length > 1 && (input.charAt(1) == "b" || input.charAt(1) == "#"))
                return input.substr(0, 2);
            else
                return input.substr(0, 1);
        };

        var getKeyByName = function (name: string) {
            if (name.charAt(name.length - 1) == "m") {
                name = name.substring(0, name.length - 1);
            }
            for (var i = 0; i < keys.length; i++) {
                if (name == keys[i].name) {
                    return keys[i];
                }
            }
        };

        var getNewKey = function (oldKey: string, delta: number, targetKey: string) {
            var keyValue = getKeyByName(oldKey).value + delta;

            if (keyValue > 11) {
                keyValue -= 12;
            } else if (keyValue < 0) {
                keyValue += 12;
            }

            var i = 0;
            if (keyValue == 0 || keyValue == 2 || keyValue == 5 || keyValue == 7 || keyValue == 10) {
                // Return the Flat or Sharp Key
                switch (targetKey) {
                    case "A":
                    case "A#":
                    case "B":
                    case "C":
                    case "C#":
                    case "D":
                    case "D#":
                    case "E":
                    case "F#":
                    case "G":
                    case "G#":
                        for (; i < keys.length; i++) {
                            if (keys[i].value == keyValue && keys[i].type == "S") {
                                return keys[i];
                            }
                        }
                    default:
                        for (; i < keys.length; i++) {
                            if (keys[i].value == keyValue && keys[i].type == "F") {
                                return keys[i];
                            }
                        }
                }
            }
            else {
                // Return the Natural Key
                for (; i < keys.length; i++) {
                    if (keys[i].value == keyValue) {
                        return keys[i];
                    }
                }
            }
        };

        var oldChordRoot = getChordRoot(note);
        var newChordRoot = getNewKey(oldChordRoot, delta, targetKey);
        return newChordRoot.name + note.substr(oldChordRoot.length);
    }
}